const listBuilderFindings = ({ total = 0, filtersApplied = false, selected = [], credits = null, activeList = null, actions = {} } = {}) => {
  const out = [];
  const sel = Array.isArray(selected) ? selected : [];
  if (total > 10000) {
    out.push({ tone: "warn", key: "too_broad", label: "Search too broad", text: `${total.toLocaleString()} results. Add a title or location before revealing.`, actions: actions.describe ? [{ label: "Describe who you want", run: actions.describe }] : [] });
  }
  if (!filtersApplied && total > 0) {
    out.push({ tone: "neutral", key: "no_filters", label: "No filters applied", text: "Tell me who you are looking for and I will set the filters." , actions: actions.describe ? [{ label: "Describe them", run: actions.describe }] : [] });
  }
  if (credits !== null && sel.length > credits) {
    out.push({ tone: "bad", key: "over_credits", label: "Reveal will exceed credits", text: `${sel.length} selected, ${credits} credits. Select fewer or top up.` });
  }
  const existing = sel.filter(r => r.existing || r.isExisting || r.alreadyInSalesgear).length;
  if (existing) {
    out.push({ tone: "warn", key: "already_saved", label: `${existing} already in Salesgear`, text: "Revealing them again wastes credits.", actions: actions.excludeExisting ? [{ label: "Exclude existing", run: actions.excludeExisting }] : [] });
  }
  if (sel.length && !activeList) {
    out.push({ tone: "neutral", key: "save_first", label: "Save before revealing", text: "Put them in a list so you can sequence them in one go.", actions: actions.saveToList ? [{ label: "Save to list", run: actions.saveToList }] : [] });
  }
  if (!filtersApplied && !sel.length) {
    out.push({ tone: "neutral", key: "lookalike", label: "Find more like your best repliers", text: "I can turn the titles and industries of contacts who replied into filters here.", actions: actions.lookalike ? [{ label: "Find lookalikes", run: actions.lookalike }] : [] });
  }
  return out;
};

export default listBuilderFindings;
